import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor;
import { action, observable } from 'mobx';
import { Collection } from 'core/model/Collection';
import UdeQueryResultModel from './UdeQueryResultModel';
let UdeQueryResultsCollection = (_dec = observable.ref, _class = class UdeQueryResultsCollection extends Collection {
  constructor(data = {
    timestamps: [],
    rows: []
  }, options) {
    const {
      timestamps,
      rows
    } = data;
    super(rows, options);
    _initializerDefineProperty(this, "timestamps", _descriptor, this);
    this.timestamps = timestamps;
  }
  get queryRequest() {
    if (!this.parent) {
      throw new Error('UdeQueryResultsCollection must have a parent QueryRequest');
    }
    return this.parent;
  }
  get queryModel() {
    return this.queryRequest.queryModel;
  }
  get model() {
    return UdeQueryResultModel;
  }
  get url() {
    return '';
  }
  get defaultSortState() {
    return {
      direction: 'desc'
    };
  }
  get baseSort() {
    const sort = this.queryModel.query.sort?.[0] || {
      rollup: this.queryModel.primaryRollupKey,
      order: 'desc'
    };
    return {
      field: `rollups.${sort.rollup}`,
      direction: sort.order
    };
  }
  get rows() {
    return this.original || this.models;
  }

  /** Update the collection with new data without resetting state (ex. live update) */
  update(data) {
    const {
      timestamps,
      rows
    } = data;
    this.timestamps = timestamps;
    this.set(rows);
  }

  /** Replace the collection with new data and reset state (ex. new query) */
  replace(data) {
    const {
      timestamps,
      rows
    } = data;
    this.reset({
      hard: true
    });
    this.timestamps = timestamps;
    this.set(rows);
  }
  reset(options) {
    super.reset(options);
    this.timestamps = [];
  }

  // @ts-expect-error Collection serialize doesn't allow returning additional data
  serialize(data) {
    return {
      timestamps: this.timestamps,
      rows: data || this.models.map(model => model.serialize())
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "timestamps", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "replace", [action], Object.getOwnPropertyDescriptor(_class.prototype, "replace"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _class);
export { UdeQueryResultsCollection as default };